export default __webpack_public_path__ + "static/media/arrow_downward.86810797.svg";